import { flatten } from "flat";
import { DATE_FNS_SHORT_DATE_FORMAT } from "../constants";
import { format } from "date-fns";

export const useFieldTransformer = (filtersModel) => {
    const remapFormDefaultValues = (formValues = []) => {
        return formValues.reduce((acc, filter) => {
            // use stored id's if they were already saved in local storage
            const dictionaryParam = filtersModel[filter.id];
            const fieldId = dictionaryParam ? dictionaryParam.name : filter.id;
            acc[fieldId] = filter.value;

            return acc;
        }, {});
    };

    const extractFieldsConfig = () => {
        return Object.keys(filtersModel).reduce((acc, key) => {
            const field = filtersModel[key];

            if (!field) {
                return acc;
            }

            const { isMulti, isDate, mapTo } = field;

            acc[field.name] = {
                isMulti,
                isDate,
                mapTo,
            };

            return acc;
        }, {});
    };
    const remapFormFields = (fields, optionsMap) => {
        return Object.keys(fields)
            .filter((fieldKey) => {
                if (Array.isArray(fields[fieldKey])) {
                    return fields[fieldKey].length;
                }

                return !!fields[fieldKey];
            })
            .map((fieldKey) => {
                const dictionaryParam = extractFieldsConfig()[fieldKey];

                if (!dictionaryParam) {
                    throw new Error(`"${fieldKey}" does not exist exist in the dictionary`);
                }

                const { isMulti, isDate, mapTo } = dictionaryParam;
                let value = fields[fieldKey];

                if (Array.isArray(value)) {
                    value = value.map((params) => params.text || params.label || params.value || params);
                }

                return {
                    id: fieldKey,
                    value: isMulti ? value.split(/\r?\n/).join(",") : value,
                    isDate,
                    mapTo,
                    displayValue: findDisplayValue(fieldKey, isMulti ? value.split(/\r?\n/).join(", ") : value, optionsMap, isDate),
                };
            });
    };

    const transform = (formFields, optionsMap) => {
        const fields = flatten(formFields, { safe: true });
        const filters = remapFormFields(fields, optionsMap);

        return filters.length ? filters : undefined;
    };

    const findDisplayValue = (key, selectedValue, optionsMap, isDate) => {
        // it's currently difficult to find a generic solution to identify date value in a string - this solution is temp, we have only 2 date fields for now
        if (isDate) {
            return format(new Date(selectedValue), DATE_FNS_SHORT_DATE_FORMAT);
        }

        // handler for multiselect values stored as array
        if (Array.isArray(selectedValue)) {
            return selectedValue.join(", ");
        }

        const options = optionsMap && optionsMap[key];

        if (!options) {
            return selectedValue;
        }

        const item = options.find(({ value }) => value.toString() === selectedValue);

        if (!item) {
            return selectedValue;
        }

        return item.text;
    };

    return {
        transform,
        remapFormDefaultValues,
    };
};
